import React, { useState, useEffect, useRef, useContext } from "react";
import {
  DatePicker,
  Row,
  Divider,
  Col,
  Card,
  Button,
  Modal,
  Radio,
  notification,
} from "antd";
import moment from "moment";
import "../../../assets/css/tms-darshanam/tms-pos-darshanam.scss";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import { RightOutlined } from "@ant-design/icons";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import TmsPrintTicket from "../../../components/tms-print-ticket/tms-print-ticket";
import TmsStringUtils from "../../../utils/tms-string-utils/tms-string-utils";
import { BaseContext } from "../../../contexts/BaseContext";
import TmsAnnadanamService from "../../../services/anndanam.service";
import Webcam from "react-webcam";
import TmsCommonService from "../../../services/tms-common.service";

const PosDarshanam = ({ router }) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const [bookingDate, setBookingDate] = useState(moment());
  const [annadanamList, setAnnadanamList] = useState([]);
  const [persons, setPersons] = useState(1);
  const [price, setPrice] = useState();
  const [annadanamSlotId, setAnnadanamSlotId] = useState();
  const [annadanamId, setAnnadanamId] = useState();
  const [externalPrint, setExternalPrint] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [array, setArray] = useState([]);
  const [updateFlag, setUpdateFlag] = useState();
  const [ticketType, setTicketType] = useState();
  const webcamRef = useRef(null);
  const { userDetails } = useContext(BaseContext);

  const { setCouponCode, setVerifiedCouponData, setUsedBy } =
    useContext(BaseContext);

  const ref = useRef(null);

  const annadanamData = (data, imgSrc) => {
    let schemaBody = [];
    const generalBody = [
      [
        "Date",
        moment(data?.annadanamBooking?.booking.booking_date).format(
          "DD-MM-YYYY"
        ),
        { margin: "0" },
      ],
      ["Time Slot", data?.annadanamBooking?.timeSlot, { margin: "0" }],
      ["Gender", data?.annadanamBooking?.booking?.gender, { margin: "0" }],
      [
        "footer",
        data?.ticket,
        {},
        data?.annadanamBooking?.annadanamName,
        `<p style="margin:0">TI No:${data?.counter_category_transaction_id
          ?.split("-")
          ?.pop()}</p><p style="margin:0">S No:${data?.daily_category_transaction_id
          ?.split("-")
          ?.pop()}</p><p style="margin:0">${moment(
          data?.annadanamBooking?.booking?.booking_date
        ).format(
          "DD-MM-YYYY"
        )}</p><p style="font-weight:bold;font-size:22px;margin:0">Rs. ${
          data?.annadanamBooking?.booking?.price
        }.00</p> `,
        !data?.productDetails?.productMetadata?.termsAndConditions ||
        data?.productDetails?.productMetadata?.termsAndConditions[0] === ""
          ? null
          : data?.productDetails?.productMetadata?.termsAndConditions
              ?.map((item, i) => {
                return `<p style="margin:0" key=${i}>${item}</p>`;
              })
              .join(" "),
        data?.createdAt,
        imgSrc,
      ],
    ];
    const miniTicketBody = [
      [
        "Total Amount",
        `Rs. ${data?.annadanamBooking?.booking.price}.00 `,
        { margin: "0", fontWeight: "800" },
      ],
      ["footer", data?.ticket, {}, {}, {}, null, data?.createdAt],
    ];
    const basicBody = [
      [
        "header",
        data?.counter_category_transaction_id?.split("-")?.pop(),
        {},
        data?.daily_category_transaction_id?.split("-")?.pop(),
        data?.ticket,
      ],
      [
        "Ticket Id",
        data?.productDetails?.productMetadata?.ticketType === "mini_ticket"
          ? data?.ticket?.split("-")?.pop()
          : data?.ticket,
        { margin: "0" },
      ],
      [
        "Anndanam",
        data?.annadanamBooking?.annadanamName,
        { margin: "0", fontWeight: "700" },
      ],
    ];
    miniTicketBody;
    if (data?.productDetails?.productMetadata?.ticketType === "mini_ticket") {
      schemaBody = [...schemaBody, ...basicBody, ...miniTicketBody];
    } else {
      schemaBody = [...schemaBody, ...basicBody, ...generalBody];
    }
    setArray([...schemaBody]);
  };

  const fetchAnnadanam = async () => {
    document.getElementById("searchable")?.focus();

    if (persons) {
      setButtonLoading(true);
      try {
        setAnnadanamList([]);
        // let id = [];
        // let dragList = [];
        let res = await TmsAnnadanamService.fetchAnnadanamBookingSlots(
          persons,
          moment(bookingDate).format("YYYY-MM-DD")
        );
        setAnnadanamList(res);
        console.log(res);
        setAnnadanamSlotId(res[0]?.vr_annadanam_slots?.id);
      } catch (error) {
        catchErrorFunction(
          error,
          "Token Expired, redirecting to login page in 5 seconds",
          router
        );
      }
      setButtonLoading(false);
    }
  };

  const AnnadanamBooking = async (type) => {
    const imageSrc = await webcamRef?.current?.getScreenshot();

    // Convert the base64 image data to a binary Blob
    const binaryData = atob(imageSrc.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: "image/jpeg" });

    let formData = new FormData();
    formData.append("file", blob);

    const url = await TmsCommonService.uploadTempFile(
      formData,
      "person",
      userDetails.user.id
    );
    if (buttonLoading) {
      return;
    }
    setButtonLoading(true);
    if (persons === "") {
      notification.info({
        message: "No of Persons cannot be empty",
      });
      setButtonLoading(false);
      return;
    }
    if (annadanamSlotId === "" || !annadanamSlotId) {
      notification.info({
        message: "Please select a slot",
      });
      setButtonLoading(false);
      return;
    }
    if (imageSrc === null || !imageSrc) {
      notification.info({
        message: "Please capture a photo",
      });
      setButtonLoading(false);
      return;
    }

    try {
      const data = await TmsAnnadanamService.annadanamBooking(
        annadanamSlotId,
        type,
        url.path
      );
      annadanamData(data, imageSrc);
      setIsModalVisible(true);
      setExternalPrint(true);
      setPersons("");
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    setCouponCode("");
    setVerifiedCouponData(null);
    setUsedBy("direct");
    fetchAnnadanam();
    if (persons) {
      setPrice();
    }
  }, [bookingDate, persons, updateFlag]);
  // Add keyboard event handler

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Only process if not loading and a slot is selected
      if (!buttonLoading && annadanamSlotId) {
        if (event.key.toLowerCase() === "m") {
          AnnadanamBooking("male");
        } else if (event.key.toLowerCase() === "f") {
          AnnadanamBooking("female");
        }
      }
    };

    // Add event listener
    window.addEventListener("keypress", handleKeyPress);

    // Cleanup
    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [buttonLoading, annadanamSlotId]); // Dependencies array includes variables used in the handler

  // const capture = useCallback(async () => {
  //   setImgSrc(imageSrc);
  // }, [webcamRef]);

  const selectSlot = (darshanamSlotId, productId) => {
    if (productId !== annadanamId) {
      setCouponCode(null);
      setVerifiedCouponData(null);
    }
    setAnnadanamSlotId(darshanamSlotId);
    setAnnadanamId(productId);
    // setTicketPrice(ticketPrice);
    // setPrice(ticketPrice * persons);
    ref?.current?.focus();
    ref?.current?.focus();
  };

  return (
    <div className="darshanamBody">
      <Card className="darshanamBodyCard">
        {" "}
        <Row justify="center" className="darshanamTitle">
          Annadanam
        </Row>
        <Divider />
        <Row gutter={(20, 20)} style={{ justifyContent: "flex-start" }}>
          <Col style={{ width: "30%" }}>
            <Row className="darshanamBookingDate">Booking Date</Row>
            <Row>
              <DatePicker
                disabled={true}
                size="medium"
                allowClear
                defaultPickerValue={moment()}
                format="DD-MM-YYYY"
                value={bookingDate}
                onChange={(e) => {
                  setBookingDate(e);
                  ref?.current?.focus();
                }}
                disabledDate={(d) =>
                  !d || d.isBefore(TmsStringUtils.addDays(new Date(), -1))
                }
                style={{ width: "100%" }}
              />
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col xs={24} sm={24} md={12} lg={16} xl={16} xsl={16}>
            {annadanamList?.length !== 0 && persons ? (
              <div style={{ marginBottom: "20px" }}>
                <Row>
                  <h1 className="resultsTitle">Annadanam</h1>
                </Row>
                <Row gutter={[20, 20]} className="resultsRow">
                  {annadanamList
                    // ?.filter((item) => ids?.includes?.(item?.id))
                    ?.map((item) => {
                      if (1 > item?.available_booking_count) {
                        // eslint-disable-next-line array-callback-return
                        return;
                      } else
                        return (
                          <Col
                            style={{
                              float: "left",
                            }}
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            xsl={12}
                          >
                            <Card
                              className="darshanamCard"
                              title={
                                <Row>
                                  <Col
                                    style={{ textAlign: "left", width: "80%" }}
                                  >
                                    {
                                      item?.vr_annadanam_slots?.vr_annadanam
                                        ?.name
                                    }{" "}
                                    <Row className="timeStamp">
                                      (
                                      {moment(
                                        item?.vr_annadanam_slots?.start_time,
                                        "HH:mm:ss"
                                      ).format("hh:mm A")}{" "}
                                      -{" "}
                                      {moment(
                                        item?.vr_annadanam_slots?.end_time,
                                        "HH:mm:ss"
                                      ).format("hh:mm A")}
                                      )
                                    </Row>
                                  </Col>

                                  <Col
                                    style={{ textAlign: "right", width: "20%" }}
                                  >
                                    <Radio
                                      defaultChecked={false}
                                      value={item?.vr_annadanam_slots?.id}
                                      checked={
                                        item?.vr_annadanam_slots?.id ===
                                        annadanamSlotId
                                          ? true
                                          : false
                                      }
                                      id={item?.vr_annadanam_slots?.id}
                                      onClick={() => {
                                        if (1 > item?.available_booking_count) {
                                          return;
                                        }
                                        selectSlot(
                                          item?.vr_annadanam_slots?.id,
                                          item?.vr_annadanam_slots?.vr_annadanam
                                            ?.id
                                        );
                                      }}
                                    />
                                  </Col>
                                </Row>
                              }
                              hoverable
                              onClick={() =>
                                selectSlot(
                                  item?.vr_annadanam_slots?.id,
                                  item?.vr_annadanam_slots?.vr_annadanam?.id
                                )
                              }
                              style={{}}
                            >
                              <Row>
                                <Col
                                  style={{
                                    width: "70%",
                                    borderRight: "2px solid #f0f2f5",
                                  }}
                                >
                                  <Row style={{ fontSize: "15px" }}>
                                    <Row justify="space-between">
                                      <Col
                                        span={11}
                                        style={{ textAlign: "left" }}
                                      >
                                        Male:{" "}
                                        <b style={{ padding: "0px 2px" }}>
                                          {item?.male_count ?? 0}
                                        </b>
                                      </Col>
                                      |{" "}
                                      <Col
                                        span={11}
                                        style={{ textAlign: "left" }}
                                      >
                                        Female:{" "}
                                        <b style={{ padding: "0px 2px" }}>
                                          {item?.female_count ?? 0}
                                        </b>{" "}
                                      </Col>
                                      <Col
                                        span={11}
                                        style={{ textAlign: "left" }}
                                      >
                                        Total :{" "}
                                        <b style={{ padding: "0px 2px" }}>
                                          {item.total_bookings_count ?? 0}
                                        </b>
                                      </Col>
                                      |{" "}
                                      <Col
                                        span={11}
                                        style={{ textAlign: "left" }}
                                      >
                                        Scanned:{" "}
                                        <b style={{ padding: "0px 2px" }}>
                                          {item?.scanned ?? 0}
                                        </b>{" "}
                                      </Col>
                                    </Row>
                                  </Row>
                                </Col>
                                <Col className="ticketCount">
                                  {item?.available_booking_count ?? 0}
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        );
                    })}
                </Row>
                <br />
                <Row style={{ display: "flex", gap: "10px" }}>
                  <Button
                    ref={ref}
                    type="primary"
                    onClick={() => {
                      buttonLoading === false && AnnadanamBooking("male");
                    }}
                    loading={buttonLoading}
                  >
                    Male <RightOutlined />
                  </Button>
                  <Button
                    ref={ref}
                    type="primary"
                    onClick={() => {
                      buttonLoading === false && AnnadanamBooking("female");
                    }}
                    loading={buttonLoading}
                  >
                    Female <RightOutlined />
                  </Button>
                </Row>
              </div>
            ) : (
              <>
                {bookingDate && !buttonLoading ? (
                  <>
                    <div
                      style={{
                        position: "relative",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {persons
                        ? `No Slots available on ${moment(bookingDate).format(
                            "DD-MM-YYYY"
                          )}`
                        : "Enter No. of Tickets"}
                    </div>
                  </>
                ) : (
                  bookingDate && (
                    <>
                      <div style={{ position: "relative", textAlign: "left" }}>
                        Fetching slots...Please wait{" "}
                      </div>
                    </>
                  )
                )}
              </>
            )}
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={8} xsl={8}>
            <Divider type="vertical" />
            <>
              <div
                className="container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "300px",
                    height: "250px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Webcam
                    className="annadanamcapture"
                    width={300}
                    height={250}
                    ref={webcamRef}
                  />
                </div>
              </div>{" "}
            </>
          </Col>
        </Row>
        <Divider />
        <Row gutter={(20, 20)} style={{ justifyContent: "center" }}></Row>
        <Row>
          <Modal
            visible={isModalVisible}
            width={450}
            footer={null}
            closable={false}
            centered
            maskClosable={false}
          >
            <TmsPrintTicket
              data={array}
              setData={setArray}
              type="annadanam"
              from="Counter"
              externalPrint={externalPrint}
              setExternalPrint={setExternalPrint}
              setButtonLoading={setButtonLoading}
              setPrintTicketModal={setIsModalVisible}
              ticketType={ticketType}
            />
          </Modal>
        </Row>
      </Card>
    </div>
  );
};

export default withRouter(PosDarshanam);
